import styled from 'styled-components';
import colors from '../../../../config/colors.json';

export const ErrorMessage = styled.span`
	color: ${colors.red};
	display: flex;
	font-size: 10px;
`;
